module.exports = __webpack_public_path__ + "static/media/duckies.5217dcf0.png";